export enum ElementIdType {
  Activity = 'Activity',
  Transition = 'Flow', //! not a shape btw
  Gateway = 'Gateway',
  StartEvent = 'StartEvent',
  Event = 'Event',
  Workflow = 'Participant',
  Lane = 'Lane', // ? what's the best name here? Group?
  Collaboration = 'Collaboration'
}

export enum ElementType {
  Form = 'trace:Form',
  TableImporter = 'trace:TableImporter',
  TableEditor = 'trace:TableEditor',
  Collaboration = 'bpmn:Collaboration',
  Participant = 'bpmn:Participant',
  Lane = 'bpmn:Lane',
  StartEvent = 'bpmn:StartEvent',
  EndEvent = 'bpmn:EndEvent',
  SequenceFlow = 'bpmn:SequenceFlow',
  MessageFlow = 'bpmn:MessageFlow',
  ExclusiveGateway = 'bpmn:ExclusiveGateway',
  InclusiveGateway = 'bpmn:InclusiveGateway',
  ParallelGateway = 'bpmn:ParallelGateway'
}

export type ModdleElement = {
  id: string;
  name: string;
  $type: ElementType;
  [key: string]: unknown;
};
